<template>
    <div class="story-main">
      <!-- <div class="story-name">
        <img :src="require('@/assets/zs.png')" mode="aspectFill"/>
        馆中背景墙故事
        <img :src="require('@/assets/zs.png')" mode="aspectFill"/>
      </div> -->
      <div class="story-main-text" v-if="description.length < 50 || !needExpend">
        {{description}}
      </div>
      <div class="story-main-text" v-else>
        {{isShow?description:galleryDesc}} <div v-if="isFont" @click="isShow=!isShow">{{ isShow?'收起' : '展开' }}</div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    description: {
      tyep: String,
      default: ''
    },
    needExpend: {
      tyep: Boolean,
      default: true
    }
  },
  data () {
    return {
      isShow: false
    }
  },
  computed: {
    isFont () {
      if (this.description.length > 50) {
        return true
      }
      return false
    },
    galleryDesc () {
      if (this.description !== null) {
        return this.description.substring(0, 48) + '...'
      }
      return ''
    }
  }
}
</script>

<style lang="scss" scoped>
.story-main {
    margin-top: 14px;
      .story-name {
        height: 24px;
        text-align: center;
        line-height: 24px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #B88652;
        border-radius: 8px 0px 16px 0px;
        margin-bottom: 15px;

        >img {
          width: 16px;
          height: 14px;
          margin-right: 10px;

          &:last-child {
            transform: rotateY(180deg);
            margin-left: 10px;
          }
        }
      }

      .story-main-text {
        font-size: 15px;
        font-family: PingFang SC;
        color: #333;
        line-height: 1.8;
        text-align: justify;
        div {
          color: #B88653;
          cursor: pointer;
          word-break: keep-all;
          display: inline-block;
          float: right;
        }
      }

      .icon {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 12px;
        height: 12px;

        >img {
          width: 100%;
          height: 100%;
        }
      }
    }
</style>
